<template>
<CModal @mtdclosemodal="mtdClose" :show.sync="boo_modal" :close-on-backdrop="false" :centered="false" :title="title" :size="'md'" :btn_cancel="true" :btn_ok="true" :booTitile="true">
    <div class="px-3 row d-flex mt-2">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-1">
            <input type="file" class="form-control" lang="es" name="file" ref="fileInput" @change="getFile"/>
        </div>
    </div>

    <template #footer>
        <button class="btn btn-success btn-sm" @click="mtdInsert" :disabled="mtdDisableButton">
            <i class="fas fa-save" />&nbsp; Guardar
        </button>
        &nbsp;
    </template>
    <SweetAlert :swal="swal" ref="SweetAlert" />
</CModal>
</template>

<script>
import CModal from "@/components/shared/modals/CModal.vue";
import SweetAlert from '@/components/shared/SweetAlert/SweetAlert.vue';
import {
    mapActions
} from "vuex";
export default {
    name: "c-logistica-upload",
    components: {
        CModal,
        SweetAlert
    },
    data() {
        return {
            swal: null,
            file: "",
        };
    },
    props: {
        title: String,
        boo_modal: Boolean,
        id: Number,
    },
    computed: {
        mtdDisableButton() {
            return this.file == "";
        }
    },

    methods: {
        ...mapActions(["get", "post"]),

        getFile(e) {
            let fileInput = this.$refs.fileInput;
            let file = e.target.files[0];
            if (!/\.(pdf)$/i.test(file.name)) {
                this.$refs.SweetAlert.showInfo("Seleccione un archivo formato PDF");
                fileInput.value = '';
                this.file = '';
            } else {
                this.file = file;
            }
        },

        mtdClose() {
            this.clear();
            this.$emit("mtdcloseModal");
        },

        clear(){
            let fileInput = this.$refs.fileInput;
            fileInput.value = '';
            this.file = '';
        },

        mtdInsert: function () {
            this.$emit("mtdInsert", this.file, this.id);
            this.mtdClose();
        }

    },
};
</script>
